import { LoadingDialog } from '@/components/controls';
import { useDeleteWatch, useWatch, useUpsertWatch } from '@/hooks';
import { useMemo } from 'react';
import { PrisonerEditorDialog } from './PrisonerEditorDialog';

export function PrisonerEditor({ code, isOpen, onClose, groupCodes }) {
  const defaultPrisoner = useMemo(
    () => ({
      name: '',
      custodyNumber: '',
      occurrenceNumber: '',
      offence: '',
      arrestingOfficerCode: '',
      investigatingOfficerCode: '',
      officerInCaseCode: '',
      arrivalTime: '',
      custodyUnit: '',
      observationLevel: '',
      groupCodes,
    }),
    [groupCodes],
  );
  const {
    query: { data: fetchedPrisoner },
  } = useWatch(code);
  const prisoner = code === 'new' ? defaultPrisoner : fetchedPrisoner;
  const { mutateAsync: upsertPrisoner } = useUpsertWatch();
  const { mutate: deletePrisoner, isPending: isDeleting } = useDeleteWatch();

  async function handleClose(values) {
    if (values) {
      await upsertPrisoner(values);
    }

    onClose();
  }

  function handleDelete() {
    deletePrisoner(code);

    onClose();
  }

  return prisoner ? (
    <PrisonerEditorDialog
      prisoner={prisoner}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      groupCodes={groupCodes}
      isDeleting={isDeleting}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
